<template>
    <SoilCharacteristicsTable :results="results" />
</template>

<script>
import SoilCharacteristicsTable from '@/components/modus/result/views/detailed/tables/SoilCharacteristicsTable.vue';
import ResultModel from "@/models/modus/ResultModel";
export default {
    name: "SoilCharacteristics",
    components: { SoilCharacteristicsTable },
    props: {
        results: {
            type: Object,
            default: () => new ResultModel()
        }
    },
};
</script>